import { render } from "./add-new-doctor.vue?vue&type=template&id=080ba04f&scoped=true"
import script from "./add-new-doctor.vue?vue&type=script&lang=js"
export * from "./add-new-doctor.vue?vue&type=script&lang=js"

import "./add-new-doctor.vue?vue&type=style&index=0&id=080ba04f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080ba04f"]])

export default __exports__